export default __webpack_public_path__ + "images/170aa8a22237b193c61fe351fb79ff23-5_4K_1920x544.jpg";